@if (sortable) {
<div
  class="grid-container"
  [nxtSortablejs]="items"
  [config]="sortableOptions"
  [ngClass]="{
    'products-grouped': groupedByCategory,
    'commercial-list': isCommercialList
  }"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>
} @else {
<div
  class="grid-container"
  [ngClass]="{
    'products-grouped': groupedByCategory,
    'mb-4': !items?.length
  }"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>
}

<ng-template #content>
  @if (renderMedia) {
  <div
    class="media-wrapper"
    [ngClass]="mediaSizeClass$ | async"
    atxMediaAspectRatio
    (mediaAspectRatio)="trueMediaAspectRatio$$.next($event)"
  >
    <ng-content select="[media]"></ng-content>
  </div>
  }

  <ng-content select="[listItems]"></ng-content>
</ng-template>
